// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { PurchaseOrder, purchaseOrderSchema } from '@/purchase-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the cancel purchase order API endpoint.
 */
const cancelPurchaseOrderResponseSchema = z.object({
  data: purchaseOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Cancels an existing purchase order with the specified reason.
 *
 * @param purchaseOrderKey - The key of the purchase order to cancel
 * @param reason - The reason for cancellation
 * @returns The cancelled purchase order
 */
export async function cancelPurchaseOrder(
  purchaseOrderKey: string,
  reason: string
): Promise<PurchaseOrder> {
  const url = `/v1/purchase-order/${purchaseOrderKey}/cancel`;
  const response = await api.post(url, { cancellationReason: reason });

  const { data } = await parseResponse(
    cancelPurchaseOrderResponseSchema,
    response.data,
    {
      schemaName: 'CancelPurchaseOrder',
      endpoint: url,
    }
  );
  return data;
}
